export default class ProductQuantity {
    constructor(productId, collectionId, quantity) {
        this.productId = Number(productId)
        this.collectionId = Number(collectionId)
        this.quantity = quantity
    }
}